export const HomeData = [{
    id: 13,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/P91768/accusure-pulse-oximeter-2-1654234170.jpg",
    title: "Accusure Pulse Oximeter",
    mrp: 719,
    strike: 3999,
    discount: 82,
  },
  {
    id: 14,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/239997/luciara-cream-safe-guard-against-stretch-marks-50-g-1-1654078411.jpg",
    title: "Luciara Cream Safe-guard Against Stretch Marks",
    mrp: 416,
    strike: 595,
    discount: 30,
  },
  {
    id: 15,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/G62192/liveasy-foods-chia-seeds-2-1654756874.jpg",
    title: "Liveasy Foods Chia Seeds",
    mrp: 224,
    strike: 249,
    discount: 10,
  },
  {
    id: 16,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/R91702/pediasure-7-vanilla-refill-400-gm-1-1654234038.jpg",
    title: "Pediasure 7+ Vanilla Refill - 400 Gm",
    mrp: 386,
    strike: 425,
    discount: 9,
  },
  {
    id: 17,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/I10558/everyuth-naturals-advanced-golden-glow-peel-off-mask-with-24k-gold-90-gm-2-1643980643.jpg",
    title: "Everyuth Naturals Advanced Golden Glow Facewash",
    mrp: 100,
    strike: 125,
    discount: 20,
  },
  {
    id: 18,
    img1: "https://cdn01.pharmeasy.in/dam/products_otc/T12046/lacto-calamine-face-wash-with-kaolin-clay-for-oily-skin-deep-cleanser-100-ml-2-1649841745.jpg",
    title: "Lacto Calamine Face Wash With Kaolin Clay Facewash",
    mrp: 94,
    strike: 120,
    discount: 21,
  }]